if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        
        this.mql = window.matchMedia('(min-width: 750px)');
        
        this.hideOverflow();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      hideOverflow() {
        const productInfoContainer = document.querySelector(".product__info-container");
        if (!productInfoContainer) return;

        const wrapper = this.elements.viewer;
        if (!wrapper) return;

        // check if mobile
        if (window.matchMedia('(max-width: 749px').matches) return;
        
        const infoHeight = productInfoContainer.scrollHeight;

        const thumbnails = wrapper.querySelectorAll("li");

        // find which elements start beyond infoHeight and give them a class
        thumbnails.forEach((thumbnail) => {
          const isOverflowing = thumbnail.offsetTop >= infoHeight;
          thumbnail.classList.toggle("thumbnail-overflow", isOverflowing);
        });

        // show & hide buttons
        const showMoreBtn = wrapper.querySelector("#mediaGalleryShowMoreBtn");
        const showLessBtn = wrapper.querySelector("#mediaGalleryShowLessBtn");

        if (showMoreBtn) {
          showMoreBtn.addEventListener("click", () => {
            showMoreBtn.closest("slider-component").querySelectorAll("li.thumbnail-overflow").forEach((thumbnail) => {
              thumbnail.classList.remove("thumbnail-overflow");
              thumbnail.classList.add("thumbnail-overflow-shown");
            });

            showMoreBtn.classList.add("hidden");
            if (showLessBtn) {
              showLessBtn.classList.remove("hidden");
            }
          });

          showMoreBtn.classList.remove("hidden");
        }

        if (showLessBtn) {
          showLessBtn.addEventListener("click", () => {
            const slider = showLessBtn.closest("slider-component");

            const lastVisible = slider.querySelector("li:not(.thumbnail-overflow-shown):not(:has(~ li:not(.thumbnail-overflow-shown)))");

            const collapseThumbnails = () => {
              showLessBtn.closest("slider-component").querySelectorAll("li.thumbnail-overflow-shown").forEach((thumbnail) => {
                thumbnail.classList.remove("thumbnail-overflow-shown");
                thumbnail.classList.add("thumbnail-overflow");
              });

              showLessBtn.classList.add("hidden");
              if (showMoreBtn) {
                showMoreBtn.classList.remove("hidden");
              }
            };

            if (lastVisible) {
              lastVisible.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });

              let scrollTimeout;
              const onScrollEnd = () => {
                collapseThumbnails();
                window.removeEventListener("scrollend", onScrollEnd);
                clearTimeout(scrollTimeout);
              };

              window.addEventListener("scrollend", onScrollEnd, { once: true });

              scrollTimeout = setTimeout(() => {
                collapseThumbnails();
                window.removeEventListener("scrollend", onScrollEnd);
              }, 2000);
            } else {
              collapseThumbnails();
            }
          });
        }
      }
    }
  );
}
